import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import CanvasConfetti from "react-canvas-confetti";

const ThankYouPage = () => {
    const refConfetti = useRef(null);
    const navigate = useNavigate();

    useEffect(() => {
        if (refConfetti.current) {
            refConfetti.current({
                particleCount: 200,
                spread: 160,
                startVelocity: 50,
                origin: { y: 0.6 },
            });
        }

        // Redirect to home page after 5 seconds
        const timer = setTimeout(() => {
            navigate("/");
        }, 5000);

        return () => clearTimeout(timer);
    }, [navigate]);

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-900 text-white text-center">
            <h1 className="text-4xl font-bold mb-4">🎉 Thank You for Your Donation! 🎉</h1>
            <p className="text-lg">Your generosity makes a difference. We appreciate your support!</p>

            {/* Fireworks Effect */}
            <CanvasConfetti refConfetti={refConfetti} className="absolute inset-0 pointer-events-none" />

            <p className="mt-4 text-sm">Redirecting to the homepage in 5 seconds...</p>
        </div>
    );
};

export default ThankYouPage;
